import wx from 'weixin-js-sdk';

export {
    WxFeatures
}

let defaultConfigOption = [];

function WxFeatures(paramsDataJson) {
    defaultConfigOption = {
        wxConfig: paramsDataJson['wxConfig'],
        wxTitle: paramsDataJson['wxTitle'],
        wxLink: paramsDataJson['wxLink'],
        wxImgUrl: paramsDataJson['wxImgUrl'],
        wxDesc: paramsDataJson['wxDesc'],
        wxType: paramsDataJson['wxType'],
        wxDataUrl: paramsDataJson['wxDataUrl'],
    };
    this.init();
}

WxFeatures.prototype = {

    init: function () {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: defaultConfigOption.wxConfig.AppId, // 必填，公众号的唯一标识
            timestamp: defaultConfigOption.wxConfig.Timestamp, // 必填，生成签名的时间戳
            nonceStr: defaultConfigOption.wxConfig.NonceStr, // 必填，生成签名的随机串
            signature: defaultConfigOption.wxConfig.Signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', "onMenuShareAppMessage"],
        });
        this.wxJsApiList();

    },
    wxJsApiList: function () {

        wx.ready(function () {
            //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
            wx.updateAppMessageShareData({
                title: defaultConfigOption.wxTitle, // 分享标题
                desc: defaultConfigOption.wxDesc, // 分享描述
                link: defaultConfigOption.wxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: defaultConfigOption.wxImgUrl, // 分享图标
                success: function () {
                    // 设置成功
                }
            });
            //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
            wx.updateTimelineShareData({
                title: defaultConfigOption.wxTitle, // 分享标题
                link: defaultConfigOption.wxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: defaultConfigOption.wxImgUrl, // 分享图标
                success: function () {
                    // 设置成功
                }
            });
            wx.onMenuShareTimeline({
                title: defaultConfigOption.wxTitle, // 分享标题
                link: defaultConfigOption.wxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                imgUrl: defaultConfigOption.wxImgUrl, // 分享图标
                success: function () {
                    // 用户点击了分享后执行的回调函数
                }
            });
            wx.onMenuShareAppMessage({
                title: defaultConfigOption.wxTitle, // 分享标题
                desc: defaultConfigOption.wxDesc, // 分享描述
                link: defaultConfigOption.wxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                imgUrl: defaultConfigOption.wxImgUrl, // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果 type 是music或video，则要提供数据链接，默认为空
                success: function () {
                    // 用户点击了分享后执行的回调函数
                }
            });
        });
    }
};




// WEBPACK FOOTER //
// ./src/assets/js/wxFeatures.js